export default __webpack_public_path__ + "static/page-header-dont-1-8f518f13eeb9c9a7e96a819da9b538d6b401a601230c7ebff77de0f6d78b6868.png";